import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetMonedasList = ()  => {
    const api = useApi();

    const mutate = async () => {
        const data  = await api.get(`/monedas`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getMonedasListMutation: mutation.mutate,
    };
}